export const DATA_KEY = "data";
export const ERRORS_PATH = ["graphQLErrors"];
export const NON_FIELD_KEY = "__all__";
export const VALIDATION_MESSAGES_KEY = "validation_messages";
export const PERMISSION_MESSAGES_KEY = "permission_error";
